import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import GroupEdit from '@/ui/pages/GroupEdit/GroupEdit';

export const Route = createFileRoute('/_dashboard/groups/$id/edit')({
  beforeLoad: requireRoute('/groups/$id/edit'),
  component: GroupEdit,
});
